export default __webpack_public_path__ + "static/media/utp11.1c88e593.jpg";